import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/components/feature/HeroSection';
import WhatIsSection from '@/components/feature/WhatIsSection';
import GuideCards from '@/components/feature/GuideCards';
import HowToSteps from '@/components/feature/HowToSteps';
import CategoriesGrid from '@/components/feature/CategoriesGrid';
import ProductShowcase from '@/components/feature/ProductShowcase';
import ComparisonTable from '@/components/feature/ComparisonTable';
import ShippingSection from '@/components/feature/ShippingSection';
import SafetySection from '@/components/feature/SafetySection';
import GuidesGrid from '@/components/feature/GuidesGrid';
import FAQSection from '@/components/feature/FAQSection';
import FinalCTA from '@/components/feature/FinalCTA';

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1">
        <HeroSection />
        <WhatIsSection />
        <GuideCards />
        <HowToSteps />
        <CategoriesGrid />
        <ProductShowcase />
        <ComparisonTable />
        <ShippingSection />
        <SafetySection />
        <GuidesGrid />
        <FAQSection />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}